export default __webpack_public_path__ + "static/media/get-started-step-3.f67f0926.png";